import React, { useMemo } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, TooltipItem } from 'chart.js';
import { PhysicalGroupsData } from '../../../services/network/form30SectorCharts-api';
import styles from './PhysicalGroupsChart.module.css';

ChartJS.register(ArcElement, Tooltip, Legend);

interface PhysicalGroupsChartProps {
    data: PhysicalGroupsData | null;
    sectorName?: string;
}

export const PhysicalGroupsChart: React.FC<PhysicalGroupsChartProps> = React.memo(({ data, sectorName }) => {
    // Проверяем, есть ли хоть какие-то данные
    const hasData = useMemo(() => {
        if (!data) return false;
        return (
            data.current_group_1 !== null ||
            data.current_group_2 !== null ||
            data.current_group_3 !== null ||
            data.current_group_4 !== null ||
            data.current_not_allowed !== null
        );
    }, [data]);

    const chartData = {
        labels: ['1 группа', '2 группа', '3 группа', '4 группа', 'Не допущен'],
        datasets: [
            {
                label: 'Количество детей',
                data: data ? [
                    data.current_group_1 || 0,
                    data.current_group_2 || 0,
                    data.current_group_3 || 0,
                    data.current_group_4 || 0,
                    data.current_not_allowed || 0,
                ] : [0, 0, 0, 0, 0],
                backgroundColor: [
                    '#1A64A5',
                    '#7EA471',
                    '#F5A742',
                    '#46A9CC',
                    '#B24CA7',
                ],
                borderColor: [
                    '#1A64A5',
                    '#7EA471',
                    '#F5A742',
                    '#46A9CC',
                    '#B24CA7',
                ],
                borderWidth: 1,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
            legend: {
                display: true,
                position: 'bottom' as const,
                labels: {
                    usePointStyle: true,
                    pointStyle: 'rect',
                    boxWidth: 22,
                    boxHeight: 22,
                    padding: 15,
                }
            },
            tooltip: {
                callbacks: {
                    label: function(context: TooltipItem<'doughnut'>) {
                        const label = context.label || '';
                        const value = context.parsed || 0;
                        const total = (context.dataset.data as number[]).reduce((a: number, b: number) => a + b, 0);
                        const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';
                        return `${label}: ${value} (${percentage}%)`;
                    }
                }
            }
        },
    };

    return (
        <div className={styles.chartContainer}>
            <h3 className={styles.chartTitle}>
                Физкультурные группы
                {sectorName && <span className={styles.sectorName}> - {sectorName}</span>}
            </h3>
            <div className={styles.chartWrapper}>
                {hasData ? (
                    <Doughnut data={chartData} options={options} />
                ) : (
                    <div className={styles.noData}>
                        <p>Нет данных для построения графика</p>
                    </div>
                )}
            </div>
        </div>
    );
});
